import React from 'react';
import PropTypes from 'prop-types';
import { CardHeader, CardHeading, Description, Card, CardContent} from './styles';

function PainelCard(props) {
  return (
    <Card>
      <CardContent>
        <CardHeader>
          <CardHeading>{props.cabecalho}</CardHeading>
          <Description dangerouslySetInnerHTML={{__html: props.descricao}}/>
        </CardHeader>
        {props.children}
      </CardContent>
      
    </Card>
  );
}

PainelCard.propTypes = {
  cabecalho: PropTypes.string,
  descricao: PropTypes.string,
}



export default PainelCard;
